import { Component, OnInit } from "@angular/core";
import { isNonCandidateApp} from '../../shared/services';
import { environment } from '../../../environments/environment';
import { Subject } from "rxjs";
import swal from "sweetalert2";
import { ControllerService } from "../../shared/services/controller.service";
import { HttpService } from "../../shared/services/http.service";
import { DomSanitizer } from "@angular/platform-browser";

declare var $: any;

type ActionEvent = {
  added: boolean,
  action: ActionObject
}

export type ActionObject = {
  title: string,
  commentParagraphs: any
  comment: string,
  image: string,
  added?: boolean
  helperImage: string,
  emailComment: string,
}

@Component({
    selector: 'app-finished',
    templateUrl: './finished.component.html',
    styleUrls: ['./finished.component.scss'],
    standalone: false
})
export class FinishedComponent implements OnInit {
  courseProgress: number;
  carousel: any;


  baseUrl = environment.audioBaseDir

  // intro + dos
  dos = []

  // just dos
  onlyDos  = []

  requiredToSelect: number = 0

  imageDirectory: string

  itemName: string

  page: number

  navButtonDisabled = false

  haveBack = false
  haveNext = false
  haveFinish = false
  sendgridTemplateId

  type =  ''

  components = []

  dontEmailActions = false

  loading: boolean = true

  finishButtonText = 'FINISH'

  eventsSubject: Subject<ActionObject> = new Subject<ActionObject>();

  constructor( private httpService: HttpService, public controller: ControllerService, private doms: DomSanitizer) { }

  getPagination(i) {
    return isNonCandidateApp(environment) ? `${i}/${this.dos.length - 1}` : `${i + 1}/${this.dos.length}`;
  }

  onSkip( ){
    this.carousel.carousel(this.dos.length)
  }


  async ngOnInit() {

      this.components = this.controller.getSectionComponents()

      const props = this.controller.getSectionProperties()

      this.itemName = props.itemName
      this.imageDirectory = props.images + '/'
      this.requiredToSelect = props.requiredToSelect

      this.dontEmailActions = props.dontEmailActions == 'true' ? true : false

      this.finishButtonText = this.dontEmailActions ? 'NEXT' : 'SEND MY ' + this.itemName.toUpperCase()

      this.type = props.type

      this.sendgridTemplateId = props.sendgridTemplateId ? props.sendgridTemplateId : ''

      this.dos = this.controller.getActions().actions

      this.onlyDos = this.dos.slice(1)

      const {items:savedActions}: any = await this.controller.getTempData('actions')
      if( savedActions ){
        for( const action of savedActions){
          const item = this.onlyDos.find( (actionItem) => this.onlyAlphaNumeric(actionItem.title) == action.title )
          if( item ) {
            item.added = true
          }
        }
      }


      this.page = this.controller.getPage()

      this.haveNext = !this.controller.isNextNewComponent()

      this.haveFinish = this.controller.isNextNewComponent()

      this.haveBack = this.page > 0

      this.loading = false
  }

  onlyAlphaNumeric( inputString: string ){
    return inputString.replace(/[^a-zA-Z0-9]/g, '');
  }

  async onAddAction(event: ActionEvent){

    const action = this.onlyDos.find( (action) => action.title == event.action.title )
    action.added = event.added

    await this.saveActions()

    this.eventsSubject.next(action);

 }

   async saveActions(){

    if( this.controller.getPreviewing() ){
      return
    }

    const myItems = this.onlyDos.filter( ({added}) => added ).map( ({title}) =>  ({title: this.onlyAlphaNumeric(title)}) )

    await this.controller.storeTempData('actions', {
      sendgridTemplateId: this.sendgridTemplateId,
      type: this.type,
      items: myItems
     })
   }

  sanitizeUrl( url ){
    return this.doms.bypassSecurityTrustUrl(url)
  }

  async onBack(index) {

    if( this.navButtonDisabled ){
      return
    }

    this.navButtonDisabled = true

    // jquery + angular = bad time
    window.setTimeout( ( ) => {
      this.navButtonDisabled = false
    }, 750 )

    $('.carousel').carousel('prev');

    await this.controller.back()

    if( this.controller.getPage() == 0 ){
      this.haveBack = false
    }

    if( !this.controller.isNextNewComponent() ){
      this.haveNext = true
      this.haveFinish = false
    }else{
      this.haveNext= false
      this.haveFinish = true
    }

  }

  async onNext() {


    if( this.navButtonDisabled ){
      return
    }
    this.navButtonDisabled = true

    // jquery + angular = bad time
    window.setTimeout( ( ) => {
      this.navButtonDisabled = false
    }, 750 )

    $('.carousel').carousel('next');

    await this.controller.next()

    if( this.controller.getPage() > 0 ){
      this.haveBack = true
    }

    if( this.controller.isNextNewComponent() ){
      this.haveNext = false
      this.haveFinish = true
    }

  }

  async onFinish(){


    if( this.onlyDos && this.onlyDos.length ){
      const myItems = this.onlyDos.filter( ({added}) => added ).map( ({title,emailComment,comment}) =>  ({title, comment : emailComment ? emailComment:comment }) )

      if( myItems.length < this.requiredToSelect ){
        swal({
          title: `Please select one or more ${this.itemName}.`,
          text: '',
          showCloseButton: true,
          customClass: 'custom-swal2-hook'
        });
        return
      }

      if( myItems.length ){
        this.controller.setSelectedActions( myItems )
        if( !this.dontEmailActions ){

          let resp: any= null
          try{
            resp = await this.httpService.postAsync("actions/send", {
              actions: myItems,
              contentId: this.controller.getContentId(),
              sendgridTemplateId: this.sendgridTemplateId,
              type: this.type
            })
          }catch(e){

          }
          if( !resp || !resp.success ){
            this.controller.setErrorMessage("Unable to send actions. Please try again.")
            return;
          }
        }
      }
    }
    this.controller.next()
  }

  onGo() {
  }
}
